import * as React from 'react';

import FameLevel from 'components/molecules/Fame/Level';

import { format } from 'helper/dateTime';
import i18n from 'helper/i18n';
import config from 'helper/mapBackendConfig';
import { template } from 'helper/string';

export type LevelType = {
	level?: string;
	id: string;
	reachedDateTime?: {
		date: string;
	};
	threshold: number;
};

export type LevelOverviewState = {};
export type LevelOverviewProps = {
	allLevels?: Array<LevelType>;
};

export default class LevelOverview extends React.Component<LevelOverviewProps, LevelOverviewState> {
	public getDescriptions(level: LevelType): Array<string> {
		const descriptions: string[] = [];

		if (level.reachedDateTime) {
			descriptions.push(
				template(
					i18n(`react.impulsCoach.components.levelOverview.reachedOnDate`),
					{ date: format((level.reachedDateTime || ({} as any)).date) },
					true
				)
			);

			if (level.threshold > 0) {
				descriptions.push(
					template(
						i18n(`react.impulsCoach.components.levelOverview.numberOfPoints`),
						{ points: level.threshold },
						true
					)
				);
			}
		} else {
			descriptions.push(
				template(
					i18n(`react.impulsCoach.components.levelOverview.reachPoints`),
					{ points: level.threshold },
					true
				)
			);
		}

		return descriptions;
	}

	public renderItems() {
		const { allLevels } = this.props;

		if (!Array.isArray(allLevels)) {
			return null;
		}

		return (
			allLevels &&
			allLevels.map((level, id) => {
				if (level.level) {
					const achieved = !!level.reachedDateTime;

					return (
						<li key={id} className="m-level-overview__list-item">
							<FameLevel
								level={level.level}
								descriptions={this.getDescriptions(level)}
								achieved={achieved}
								modifier="overview"
							/>
						</li>
					);
				}

				return null;
			})
		);
	}

	public render() {
		return (
			<div className="m-level-overview">
				<div className="m-level-overview__head">
					<img
						className="m-level-overview__figure"
						src={`${config.env.baseUrlUi}/assets/img/level-overview-figure.png`}
						alt=""
					/>
				</div>
				<div className="m-level-overview__body">
					<ul className="m-level-overview__list">
						{this.renderItems()}
						<li className="m-level-overview__list-item">
							<div className="m-level-overview__info">
								<h4 className="m-level-overview__info-title">
									{i18n(`react.impulsCoach.components.levelOverview.title`)}
								</h4>
								<p className="m-level-overview__info-text">
									{i18n(`react.impulsCoach.components.levelOverview.text`)}
								</p>
							</div>
						</li>
					</ul>
				</div>
				<div className="m-level-overview__foot">
					<img
						className="m-level-overview__figure"
						src={`${config.env.baseUrlUi}/assets/img/level-overview-figure.png`}
						alt=""
					/>
				</div>
			</div>
		);
	}
}
